import template from './password-recovery.html';
import './password-recovery.styl';

function passwordRecoveryComponent($stateParams, $tszToast, $translate, AuthService) {

  'ngInject';

  this.loading = false;

  this.data = {
    email: $stateParams.e,
    token: $stateParams.t,
  };

  this.changePassword = (form) => {

    if (form.$valid) {
      this.loading = true;
    }

    AuthService.changePassword(this.data.email, this.data.token, this.data.password)
    .then(() => {
      $tszToast.showSuccess('La contraseña ha sido cambiada satisfactoriamente');
    }).catch((err) => {
      if (err.data && err.data.code) {
        $translate(`ERROR.${err.data.code}`)
        .then((errorMsg) => {
          $tszToast.showError(errorMsg);
          this.error = errorMsg;
        });
      }
    }).finally(() => {
      // regardless of the response, change the loading state
      this.loading = false;
    });

  };
}

export default {
  template,
  controller: passwordRecoveryComponent,
};



// WEBPACK FOOTER //
// ./src/containers/password-recovery/index.js